import "whatwg-fetch"
import MD5 from "js-md5";


export const serialize = (obj) => {

}

export async function getSources(url, params) {
  // console.log(params)
  let str = Object.keys(params).map((item) => `${item}=${params[item]}`).join("&")
  let string
  if (str) {
    string = str + `&key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
  } else {
    string = str + `key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
  }

  let sign = MD5(string)

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      token: '2345n45k4n63k63n3'
    },
    body: str + `&sign=${sign}`
  }).catch((error) => {
    console.log(error)
  })

  return await response.json().catch((error) => {
    console.log(error)
  })
}

export async function getSourcesJson(url, params) {
  let paramToken;
  let tokenString = '';
  paramToken = params.split('&');
  paramToken = paramToken.map(item => {
    let a = item.split('=')
    a[0] = a[0].toUpperCase();
    return a
  })
  paramToken = paramToken.sort().reduce((a, b) => (
    a.concat(b)
  ))
  paramToken.forEach(item => {
    tokenString += item
  })
  tokenString = decodeURIComponent(tokenString)
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      paramToken: MD5(tokenString),
      token: '2345n45k4n63k63n3'
    },
    body: params
  }).catch((error) => {
    console.log(error)
  })

  return await response.json().catch((error) => {
    console.log(error)
  })
}

export function requestJson(params) {
  const url = params.url
  const method = params.method | 'GET'
  const resp = fetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Teacher-Token': getTeacherToken()
    },
    body: params.body
  }).catch((error) => {
    console.log(error)
  })
  resp.then()
}



// export async function getSourcesJson(url, params) {
//     console.log(params)
//     let str=Object.keys(params).map((item) => `${item}=${params[item]}`).join("&")
//     let string
//     if(str){
//         string=str+`&key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
//     }else{
//         string=str+`key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
//     }
//
//     let sign=MD5(string)
//
//     const response = await fetch( url, {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json",
//             token: '2345n45k4n63k63n3'
//         },
//         body: str+`&sign=${sign}`
//     }).catch((error) => {
//         console.log(error)
//     })
//
//     return await response.json().catch((error) => {
//         console.log(error)
//     })
// }
export async function getSource(url) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }).catch((error) => {
    console.log(error)
  })

  return await response.json().catch((error) => {
    console.log(error)
  })
}






// WEBPACK FOOTER //
// ./src/api.js